import React from 'react';
import { Chats } from "../../fasades/chats";
import { IBilling } from "../api/llmapi";
import { ScrollableTable, tableColumn } from "./scrollableTable";
import { DateTimePicker } from "./datetimepicker";
import "./billingoverview.css";
import { Util } from '../../fasades/util';
import { IoClose } from "react-icons/io5";
import { RoundButton } from "./roundbutton";

interface BillingOverviewProps {
    onExit: () => void;
}

interface BillingState {
    bills: IBilling[];
    startDate: Date;
    endDate: Date;
}

export class BillingOverview extends React.Component<BillingOverviewProps> {
    state: BillingState = { 
        bills: [],
        startDate: new Date(),
        endDate: new Date()
    };
    
    constructor(props: BillingOverviewProps) {
        super(props);
        this.handleStartChange = this.handleStartChange.bind(this);
        this.handleEndChange = this.handleEndChange.bind(this);
        this.updateToday = this.updateToday.bind(this);
        this.updateLastWeek = this.updateLastWeek.bind(this);
        this.updateLastMonth = this.updateLastMonth.bind(this);
        this.updateBilling = this.updateBilling.bind(this);
    }

    componentDidMount(): void {
        this.updateBilling();
    }

    updateBilling() {
        Chats.getBills(this.state.startDate, this.state.endDate).then((data) => {
            data.forEach(item => {
                item.timestamp = Util.formatDateReadable(item.timestamp)
            });
            this.setState({bills: data});
        });
    }

    updateToday() {
        this.setState({ startDate: new Date(), endDate: new Date() }, () => {this.updateBilling();});
    }

    updateLastWeek() {
        let end    = new Date();
        let start  = new Date(end);
        start.setDate(end.getDate() - 7);

        this.setState({ startDate: start, endDate: end }, () => {this.updateBilling();});
    }

    updateLastMonth() {
        let end   = new Date();
        let start = new Date(end);
        start.setDate(end.getDate() - 30);

        this.setState({ startDate: start, endDate: end}, () => {this.updateBilling();});
    }

    handleStartChange(date: Date | null) {
        if (date !== null) {
            this.setState({startDate: date}, () => {this.updateBilling();});
        }
    }

    handleEndChange(date: Date | null) {
        if (date !== null) {
            this.setState({endDate: date}, () => {this.updateBilling();});
        }
    }

    getTableColumns(): tableColumn[] {
        let billingColumns: tableColumn[] = [
            {
                label: "Timestamp",
                key: "timestamp"
            },
            {
                label: "Event Type",
                key: "type"
            },
            {
                label: "Masked Token Id",
                key: "tokenId"
            },
            {
                label: "Model",
                key: "model"
            },
            {
                label: "No. of Input Tokens",
                key: "inputTokens"
            },
            {
                label: "No. of Output Tokens",
                key: "outputTokens"
            },
            {
                label: "No. of Train Tokens",
                key: "trainingTokens"
            },
            {
                label: "Cost",
                key: "cost"
            }
        ];
        return billingColumns;
    }

    render() {
        const columns = this.getTableColumns();
        const bills = this.state.bills;

        const totals = bills.reduce(
            (acc, bill) => ({
                inputTokens: acc.inputTokens + bill.inputTokens,
                outputTokens: acc.outputTokens + bill.outputTokens,
                trainingTokens: acc.trainingTokens + bill.trainingTokens,
                cost: acc.cost + bill.cost,
            }),
            { inputTokens: 0, outputTokens: 0, trainingTokens: 0, cost: 0 }
        );

        return (
            <div className="billing-section">
                <div className="chat-header">
                    <h1 className="chat-title">Usage</h1>
                    <div className="chat-header-actions">
                        <RoundButton
                            description = { false }
                            icon = {IoClose}
                            name="Back to converstation"
                            onClick={ () => this.props.onExit() }/>
                    </div>
                </div>
                <div>
                    <div className="filter">
                        <DateTimePicker 
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            startChange={this.handleStartChange}
                            endChange={this.handleEndChange}
                        />
                        <div className="cmds">
                            <button onClick={this.updateToday}>1D</button>
                            <button onClick={this.updateLastWeek}>7D</button>
                            <button onClick={this.updateLastMonth}>Last Month</button>
                        </div>
                    </div>
                </div>
                <div className='billing-overview'>
                    <div className="table-container">
                        <div className="table-scroll">
                            <ScrollableTable tableData={bills} columns={columns}/>
                        </div>
                        {(
                            <div className="totals-scroll">
                                <table className="totals-table" style={{borderCollapse: "collapse", width: "100%", minWidth: "max-content"}}>
                                    <thead>
                                        <tr>
                                            <th style={{border: "1px solid #ccc", padding: "8px", whiteSpace: "nowrap", fontSize: ".7rem"}}></th>
                                            <th style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem"}}>No. of Input Tokens</th>
                                            <th style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem"}}>No. of Output Tokens</th>
                                            <th style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem"}}>No. of Train Tokens</th>
                                            <th style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem"}}>Cost</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem", fontWeight: "bold"}}>Total</td>
                                            <td style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem", fontWeight: "bold"}}>{totals.inputTokens}</td>
                                            <td style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem", fontWeight: "bold"}}>{totals.outputTokens}</td>
                                            <td style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem", fontWeight: "bold"}}>{totals.trainingTokens}</td>
                                            <td style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem", fontWeight: "bold"}}>${totals.cost.toFixed(4)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}